// import nprogress from '@utils/nprogress';
import config from "@config";
import store from "@store";
import router from "@router";
import axios from "axios";

const http = axios.create({
    baseURL: config.http.url,
    headers: config.http.defaultRequest.headers,
});
/**
 * Add a request and response interceptor
 */
const beforeRequestSuccess = (configurate) => {
    const token = store.getters["auth/getToken"];
    configurate.headers.Authorization = `Bearer ${token}`;
    const selectedLanguage =
        store.getters["language/getSelectedLanguage"] || "en";
    configurate.headers["Accept-Language"] =
        selectedLanguage === "English" || selectedLanguage === "en"
            ? "en"
            : "lv";

    store.dispatch("global/setAppLoading", true);

    return configurate;
};

const beforeRequestError = (error) => {
    return Promise.reject(error);
};

const onSuccess = (response) => {
    store.dispatch("global/setAppLoading", false);
    return response;
};

const onError = async (error) => {
    store.dispatch("global/setAppLoading", false);
    if (error.response) {
        const { response } = error;
        if (
            response.status === 401 &&
            !error.config.url.includes("/api/auth/logout") &&
            !error.config.url.includes("/api/auth/resume-session") &&
            !error.config.url.includes("/api/auth/rfid-login")
        ) {
            if (router.currentRoute.value.name !== 'SignIn') {
                const revalToken = store.getters["auth/getRevalidationToken"];
                if (revalToken) {
                    console.warn('[HTTP Interceptor] Received 401, attempting to resume session...');
                    try {
                        await store.dispatch("auth/resumeSession", { revalidation_token: revalToken });
                        return;
                    } catch (resumeError) {
                        console.warn('[HTTP Interceptor] Failed to resume session after 401:', resumeError?.message || resumeError);
                    }
                }
                
                console.warn('[HTTP Interceptor] Performing full logout after 401 / resume failure.');
                store.dispatch("auth/logout").catch(() => {
                    if (router.currentRoute.value.name !== 'SignIn') {
                        router.push({ name: 'SignIn' });
                    }
                });
            }           
        }
    }
    return Promise.reject(error);
};

// Apply interceptors
http.interceptors.request.use(beforeRequestSuccess, beforeRequestError);
http.interceptors.response.use(onSuccess, onError);

// Export the configured Axios instance as the default
export default http;